/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Free_PriceInputs */

const en_directory_submit_review_free_price = /** @type {(inputs: Directory_Submit_Review_Free_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0`)
};

const zh_directory_submit_review_free_price = /** @type {(inputs: Directory_Submit_Review_Free_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0`)
};

/**
* | output |
* | --- |
* | "$0" |
*
* @param {Directory_Submit_Review_Free_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_free_price = /** @type {((inputs?: Directory_Submit_Review_Free_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Free_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_free_price(inputs)
	return zh_directory_submit_review_free_price(inputs)
});
export { directory_submit_review_free_price as "directory.submit.review.free_price" }